import http from "./httpService";
import { apiUrl } from "../config";

export const getReleaseNotes = () =>
  http.get(`${apiUrl}Notification/GetReleaseNotes`);

export const getLatestNewFeatures = () =>
  http.get(`${apiUrl}Notification/GetNewFeatures`);

export const getVolumes = () => http.get(`${apiUrl}Notification/GetVolumes`);

export const getReturnsNotifications = () =>
  http.get(`${apiUrl}Notification/ReturnNotification`);

export const getReturnsNotificationHistory90Days = () =>
  http.get(`${apiUrl}Notification/GetReturnRequestHistoryFor90Days`);

export const getReturnPermissions = (data) =>
  http.get(`${apiUrl}Notification/GetReturnPermissions`, {
    params: data,
  });

export const getMaintenanceNotifications = () =>
  http.get(`${apiUrl}Notification/GetMaintenanceMessage`);

export const getCacheBustVer = () =>
  http.get(`${apiUrl}Notification/GetCacheBustVer`);
